import React, { Component } from "react";
import { connect } from "react-redux";

import { FormattedMessage } from "react-intl";

import { getTransform } from "./hotspot";

import { setSeparateProteinPredictions } from "./store/actions";

import chromo from "./img/chromo.svg";

import "./styles.scss";

class SeparateProtein extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetList: [],
      slot1: 1,
      slot2: 2,
      slot3: 3,
      card1Pos: { x: 42, y: this.props.data.band_1 },
      card2Pos: { x: 42, y: this.props.data.band_2 },
      card3Pos: { x: 42, y: this.props.data.band_3 },
      objCurrent: null,
      objPrevious: null,
    };
  }

  componentDidMount() {
    this.setState({
      targetList: [
        document.getElementById("band-drop-target_1"),
        document.getElementById("band-drop-target_2"),
        document.getElementById("band-drop-target_3"),
      ],
    });
  }

  swapCards = (targetSlot, movedCard) => {
    let prevSlot = 0;
    const swappingCard = this.state["slot" + targetSlot];

    if (this.state.slot1 === movedCard) {
      prevSlot = 1;
    } else if (this.state.slot2 === movedCard) {
      prevSlot = 2;
    } else if (this.state.slot3 === movedCard) {
      prevSlot = 3;
    }

    this.setState({
      ["slot" + targetSlot]: movedCard,
      ["slot" + prevSlot]: swappingCard,
    });
  };

  //DRAG STUFF START
  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }
    dragImage.style.position = "absolute";
    dragImage.style.top = 0;
    dragImage.style.left = 0;

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    this.unscaledStart(e, e.target);
  };

  onDragOver = (e) => {
    e.preventDefault();
    this.unscaledDrag(e);
  };

  onDrop = (e) => {
    e.preventDefault();

    if (
      this.state.objCurrent.id === "band_1" ||
      this.state.objCurrent.id === "band_2" ||
      this.state.objCurrent.id === "band_3"
    ) {
      this.props.setSeparateProteinPredictions({
        type: this.props.component_type,
        id: this.state.objCurrent.id,
        value: getTransform(this.state.objCurrent).translateY,
      });
    }

    this.end(e);
  };

  unscaledStart = (objEvent, target) => {
    const current = target;

    current.lastX = objEvent.clientX;
    current.lastY = objEvent.clientY;
    current.lastRotation = 0;
    current.isAnimated = false;
    current.style.zIndex = "99";
    current.setAttribute("aria-grabbed", "true");

    this.setState({
      objCurrent: current,
    });

    return false;
  };

  end = () => {
    // Set the current active element to null
    if (this.state.objCurrent !== null) {
      const current = this.state.objCurrent;
      const previous = this.state.objPrevious;

      current.style.zIndex = "2";
      current.setAttribute("aria-grabbed", "false");

      if (
        this.state.objPrevious !== null &&
        this.state.objPrevious !== this.state.objCurrent
      ) {
        previous.style.zIndex = "";
      }
      this.setState({
        objPrevious: this.state.objCurrent,
      });
    }
    this.setState({
      objCurrent: null,
    });

    return false;
  };

  unscaledDrag = (objEvent) => {
    if (this.state.objCurrent !== null) {
      // Calculate new position
      const iCurrentY = objEvent.clientY;

      const transform = getTransform(this.state.objCurrent);
      const iYPos = parseFloat(transform.translateY);
      const iNewY = iYPos + iCurrentY - this.state.objCurrent.lastY;

      const currentobj = this.state.objCurrent;
      if (iNewY >= -275 && iNewY <= -35) {
        currentobj.style.transform =
          "translate3d(42px, " + iNewY + "px,  0px) ";
        currentobj.lastY = iCurrentY;
        this.setState({
          objCurrent: currentobj,
        });
      }
    }
    return false;
  };

  renderBand = (band) => {
    const bands = [
      "Hydrophilic Proteins",
      "Highly hydrophobic Proteins (RFP)",
      "Moderately hydrophobic Proteins",
    ];

    return (
      <div>
        <div
          id={"band_" + band}
          className="band"
          aria-label={
            this.props.intl.formatMessage({
              id: bands[band - 1],
              defaultMessage: bands[band - 1],
              description: "",
            }) +
            this.props.intl.formatMessage({
              id: this.props.component_strings.aria1,
              defaultMessage: this.props.component_strings.aria1,
              description: "",
            }) +
            (this.state["card" + band + "Pos"].y > 126
              ? this.props.intl.formatMessage({
                  id: this.props.component_strings.aria2,
                  defaultMessage: this.props.component_strings.aria2,
                  description: "",
                })
              : this.state["card" + band + "Pos"].y > 63
                ? this.props.intl.formatMessage({
                    id: this.props.component_strings.aria3,
                    defaultMessage: this.props.component_strings.aria3,
                    description: "",
                  })
                : this.props.intl.formatMessage({
                    id: this.props.component_strings.aria4,
                    defaultMessage: this.props.component_strings.aria4,
                    description: "",
                  }))
          }
          role="button"
          draggable={this.props.editable}
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === "ArrowUp") this.onMoveUp(e, band);
            else if (e.key === "ArrowDown") this.onMoveDown(e, band);
          }}
          onClick={() => this.handleClick(band)}
          style={{
            transform:
              "translate(" +
              this.state["card" + band + "Pos"].x +
              "px, " +
              this.state["card" + band + "Pos"].y +
              "px)",
            "--before-display": this.props.editable ? "block" : "none",
          }}
        >
          <p className="label">
            <FormattedMessage
              id={bands[band - 1]}
              defaultMessage={bands[band - 1]}
              description=""
            />
          </p>
        </div>
      </div>
    );
  };

  onMoveUp = (e, band) => {
    e.preventDefault();
    console.log("move up");

    const newPos = this.props.data["band_" + band] - 1;

    if (newPos >= -275 && newPos <= -35) {
      e.target.style.transform = "translate3d(42px, " + newPos + "px,  0px) ";
      e.target.lastY = this.props.data["band_" + band];

      this.props.setSeparateProteinPredictions({
        type: this.props.component_type,
        id: "band_" + band,
        value: newPos,
      });
    }
  };

  onMoveDown = (e, band) => {
    e.preventDefault();
    console.log("move down");

    const newPos = this.props.data["band_" + band] + 1;

    if (newPos >= -275 && newPos <= -35) {
      e.target.style.transform = "translate3d(42px, " + newPos + "px,  0px) ";
      e.target.lastY = this.props.data["band_" + band];

      this.props.setSeparateProteinPredictions({
        type: this.props.component_type,
        id: "band_" + band,
        value: newPos,
      });
    }
  };

  renderBandDragArea = () => {
    return (
      <div
        className="band-drag-area"
        onDragStart={this.onDragStart}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}
      >
        <div id="band-drop-target_1" className="band-drop-target">
          {this.renderBand(this.state.slot1)}
        </div>
        <div id="band-drop-target_2" className="band-drop-target">
          {this.renderBand(this.state.slot2)}
        </div>
        <div id="band-drop-target_3" className="band-drop-target">
          {this.renderBand(this.state.slot3)}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="protein-band-results__column">
        <img src={chromo} alt="" />
        <div className="band-order-container">
          {JSON.stringify(this.props.data) === "{}"
            ? ""
            : this.renderBandDragArea()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.separateProtein[ownProps.component_type],
  };
};

export default connect(mapStateToProps, {
  setSeparateProteinPredictions,
})(SeparateProtein);
